import styled from 'styled-components';

export const Carousel = styled.div`
    height: 480px;
    position: relative;
    background-color: #2b3b46;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

export const Slide = styled.div.attrs((props) => ({
    style: {
        backgroundImage: props.image ? `url(${props.image})` : undefined,
    },
}))`
    width: 100%;
    height: 480px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 50%;
    outline: none;
    will-change: transform;
    position: absolute;
    z-index: 1;
`;
